/**
 * Responsible for loading the Highlights-Preview.
 */
import { Highlight } from "suus-api"
import { Ref, ref } from "vue"
import { getHighlights } from "features/events/highlights/highlights.functions"

export const useFetchPreviewHighlights = (eventId: number) => {
  const isLoading = ref(false)
  const error = ref(null)
  const highlights: Ref<Highlight[]> = ref([])

  const loadHighlights = async () => {
    isLoading.value = true
    try {
      highlights.value = await getHighlights(eventId, 0, 10)
    } catch (e) {
      error.value = e
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    error,
    highlights,
    loadHighlights,
  }
}
